<template>
  <section>
    <div class="footDiv">
      <ul>
        <li><i class="iconfont icon-phone"></i>&nbsp;&nbsp;预约安装服务</li>
        <li><i class="iconfont icon-gongju"></i>&nbsp;&nbsp;预约维修服务</li>
        <li><i class="iconfont icon-7tianwuliyoutuihuo"></i>&nbsp;&nbsp;7天无理由退换</li>
        <li><i class="iconfont icon-yijiantong"></i>&nbsp;&nbsp;一年免费换货</li>
        <li><i class="iconfont icon-map"></i>&nbsp;&nbsp;400余家售后网店</li>
      </ul>
      <div class="footMid">
        <div class="footMenu">
          <div class="menu1">
            <div class="title">产品信息</div>
            <div class="item">
              <router-link :to="{name: 'productDetail',query: {categoryId:146}}">
                灵耀E26
              </router-link>
            </div>
            <div class="item">
              <router-link :to="{name: 'productDetail',query: {categoryId:138}}">
                D26全新2代
              </router-link>
            </div>
            <div class="item">
              <router-link :to="{name: 'productDetail',query: {categoryId:137}}">
                D32全新2代
              </router-link>
            </div>
            <div class="item">
                奎木狼D系列
            </div>
          </div>
          <div class="menu1">
            <router-link to="/news">
              <div class="title">
                新闻中心
              </div>
              <div class="item">公司新闻</div>
              <div class="item">行业热点</div>
            </router-link>
          </div>
          <div class="menu1">
            <router-link to="/article">
              <div class="title">灯改社区</div>
              <div class="item">车友社区</div>
              <div class="item">灯改案例</div>
              <div class="item">视频展示</div>
              <div class="item">热门帖子</div>
            </router-link>
          </div>
          <div class="menu1">
            <div class="title">质保售后</div>
            <router-link to="/service">
              <div class="item">质保售后</div>
            </router-link>
          </div>
          <div class="menu1">
            <div class="title">关于我们</div>
            <router-link to="/about">
              <div class="item">公司简介</div>
            </router-link>
            <router-link to="/about/contact">
              <div class="item">联系我们</div>
            </router-link>
            <router-link to="/about/join">
              <div class="item">加入我们</div>
            </router-link>
          </div>
          <div class="menu1">
            <div class="title">电商入口</div>
            <a href="https://mall.jd.com/index-942936.html" target="_blank">
              <div class="item">京东旗舰店</div>
            </a>
            <a href="https://shop234901434.taobao.com/?spm=a1z10.3-c-s.w5001-17199353473.7.74d250f2S5M8e5&scene=taobao_shop" target="_blank">
              <div class="item">淘宝企业店</div>
            </a>
          </div>
        </div>
        <div class="footPhone">
          <div class="lx">
           <!-- <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=480707620&site=qq">
              <div><i class="iconfont icon-comments"></i>&nbsp;&nbsp;在线客服</div>
            </a>-->
            <a target="_blank" href="javascript:void(0)" @click="change()">
              <div><i class="iconfont icon-comments"></i>&nbsp;&nbsp;在线客服</div>
            </a>
          </div>
          <div class="tel">020-32885480</div>
          <div class="time">周一至周五 9:00-18:00 </div>
        </div>
        <div class="footCore">
          <img src="http://video.naolamp.com/images/index/cds.png"/>
          <div>车灯师公众号</div>
        </div>
      </div>
      <div class="footWeb">
        <div class="left">
          <div style="font-family: 'SourceHanSansCN-Light';">广州车灯师信息科技有限公司 版权所有</div>
          <div><a style="font-family: 'SourceHanSansCN-Light';" href="https://beian.miit.gov.cn">粤ICP备12059610号-3</a></div>
          <div>
            <img class="beian" :src="beiAn"/>
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011102001129" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;font-family: 'SourceHanSansCN-Light';">粤公网安备 44011102001129号</p></a>
          </div>
        </div>
        <div class="right">
          <div style="font-family: 'SourceHanSansCN-Light';">关注我们：</div>
          <div><i class="iconfont icon-xinlang"></i></div>
          <div><i class="iconfont icon-weixin"></i></div>
          <div><i class="iconfont icon-rectangle390"></i></div>
        </div>
      </div>
    </div>
    <div class="topParent">
      <div class="goTop">
        <!--<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=2159797680&site=qq&menu=yes">-->
        <a target="_blank" href="javascript:void(0)" @click="change()">
          <!--<img border="0" src="http://wpa.qq.com/pa?p=2:921449501:51" alt="点击这里给我发消息" title="点击这里给我发消息"/>-->
          <div>
            <i class="iconfont icon-qq"></i>
            <p style="font-size: 14px;padding: 0;margin-top: 3px;color: #888">在线客服</p>
          </div>
        </a>
        <a href="#" id="backTop" title="返回顶部" v-show="isFloat">
            <!--<img :src="gotop"/>-->
          <div style="margin-top: 10px;border-top: 1px solid #ccc;padding-top: 5px;">
            <i class="iconfont icon-xiangshang"></i>
            <p style="font-size: 14px;padding: 0;margin-top: 3px;color: #888">返回顶部</p>
          </div>
        </a>
      </div>
    </div>
    <iframe style="width: 0;height: 0;" :src="viewUrl"></iframe>
  </section>
</template>

<script>
export default {
  props: {
  },
  data () {
    return {
      viewUrl: '',
      defaultUrl: 'http://wpa.qq.com/msgrd?v=3&uin=480707620&site=qq',
      cdsCode: require('../../assets/image/jjy_code.png'),
      gotop: require('../../assets/icon/gotop.png'),
      beiAn: require('../../assets/image/beian.png'),
      isFloat: false,
      rame: false
    }
  },
  methods: {
    handleScroll: function () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.isFloat = (scrollTop > 680)
    },
    change () {
      this.viewUrl = this.defaultUrl
      // let iframe = document.createElement('iframe')
      // iframe.setAttribute('src', 'http://wpa.qq.com/msgrd?v=3&uin=480707620&site=qq')
      // let topParent = document.getElementsByClassName('topParent')[0]
      // iframe.parentNode.insertBefore(iframe, topParent.nextSibling)
      let that = this
      setTimeout(function () {
        console.log(13131343)
        that.viewUrl = ''
      }, 1000)
    }
  },
  mounted: function (s) {
    window.addEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
.footDiv {
  background-color: #FFFFFF;
  width: 1200px;
  margin: 0 auto;
}
.icon-phone,
.icon-gongju,
.icon-7tianwuliyoutuihuo,
.icon-yijiantong,
.icon-map{
  font-size: 24px;
}
.footDiv ul {
  display: flex;
  padding: 10px 0;
  border-bottom: 1px solid #e8e8e8;
}
.footDiv ul li {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 51px;
  line-height: 71px;
  border-right: 1px solid #e8e8e8;
  font-size: 16px;
  color: #191b1b;
  font-family: "SourceHanSansCN-Light";
  box-sizing: border-box;
}
.footDiv ul li:last-child{
  border-right: 0;
}
.footMid {
  padding: 30px 0;
  display: flex;
  border-bottom: 1px solid #e8e8e8;
}
.footMid .footMenu {
  flex: 7;
  display: flex;
  font-size: 14px;
}
.footMenu .menu1 {
  flex: 1;
}
.footMenu .menu1 .title{
  text-align: left;
  font-weight: 600;
  margin-bottom: 10px;
  color: #191b1b;
  font-family: "SourceHanSansCN-Light";
}
.footMenu .menu1 .item{
  line-height: 20px;
  text-align: left;
  margin-bottom: 5px;
  cursor: pointer;
  color: #767676;
  font-family: "SourceHanSansCN-Light";
}
.footMenu .menu1 .item:hover{
  opacity: .8;
}
.footMid .footPhone {
  flex: 3.1;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
  height: 140px;
}
.footPhone .lx .iconfont {
  font-size: 22px;
}
.footPhone .lx div {
  position: relative;
  margin: 0 auto;
  background-color: #05b570;
  color: #FFFFFF;
  width: 150px;
  height: 47px;
  line-height: 47px;
  margin-bottom: 25px;
  z-index: 10;
  border-radius: 23px;
  font-size: 18px;
}
.footPhone .tel {
  color: #05b570;
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 10px;
}
.footPhone .time {
  font-size: 14px;
  color: #767676;
}
.footMid .footCore {
  flex: 1.9;
}
.footCore img {
  height: 125px;
}
.footCore div {
  padding-left: 5px;
  font-size: 14px;
  letter-spacing: 6px;
  color: #767676;
}
.footWeb {
  padding: 20px 0 40px 0;
  font-size: 14px;
}
.footWeb .left div{
  float: left;
  padding: 0 10px;
}
.footWeb .beian{
  vertical-align: top;
}
.footWeb .right{
  padding-right: 50px;
  float: right;
}
.footWeb .right div{
  float: left;
  padding: 0 10px;
}
.topParent {
  width: 100%;
  height: 100%;
}
.goTop {
  width: 80px;
  bottom: 200px;
  right: 10px;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  background-color: #eee;
  border: 1px solid #e6e6e6;
}
.goTop img {
}
.icon-qq{
  font-size: 40px;
  color: #00a0e9;
}
.icon-xiangshang{
  font-size: 30px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/common/indexFoot.vue